import React from 'react';
import Title from "../../customer/ProductsCustomer/Title";
import CheckoutValidatePassphrase from "./Checkout/CheckoutValidatePassphrase";
import useStyles from "./Checkout/styles"

function ValidatePassphrasePage() {
    const classes = useStyles();
    return (
        <React.Fragment>
            <div className={classes.pageContainer}>
                <div className={classes.pageTitleContainer}>
                    <Title
                        title={"REGISTRO"}
                        subtitle={"Ingrese la frase de seguridad que se le ha proporcionado"}
                    />
                </div>

                <div className={classes.formBox}>
                    <CheckoutValidatePassphrase/>
                </div>

            </div>
        </React.Fragment>
    );
}

export default ValidatePassphrasePage;